import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { NotificacoesListWrapper } from './notificacoes-list/NotificacoesList'

const NotificacoesPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.notificacoes.descricao')}>Notificações</PageTitle>
              <NotificacoesListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default NotificacoesPage
